import { render } from "./ResourcesSummary.vue?vue&type=template&id=ba15c758&scoped=true"
import script from "./ResourcesSummary.vue?vue&type=script&lang=js"
export * from "./ResourcesSummary.vue?vue&type=script&lang=js"

import "./ResourcesSummary.vue?vue&type=style&index=0&id=ba15c758&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba15c758"]])

export default __exports__